// map Center
export const zoom = 12;
export const centerLat = 24.719127;
export const centerLng = 46.669663;

// map bounds
export const point1Lat = 24.75026098689889;
export const point1Lng = 46.74015820026398;
export const point2Lat = 24.688200182518774;
export const point2Lng = 46.597335934638984;

// day
export const days = {
    1: 1,
    2: 2,
    3: 3,
    4: 7,
    5: 14,
    6: 21,
    7: 30,
    8: 60,
    9: 0,
};

export const daysReverse = {
    1: 1,
    2: 2,
    3: 3,
    7: 4,
    14: 5,
    21: 6,
    30: 7,
    60: 8,
    0: 9,
};

export const getColorFromTrackingNumber = (tn) => {
    try {
        let hash = 0;
        for (let i = 0; i < tn.length; i++) {
            hash = (hash << 5) - hash + tn.charCodeAt(i);
            hash = hash & hash;
        }
        let color = "#";
        for (let i = 0; i < 3; i++) {
            let value = (hash >> (i * 8)) & 0xFF;
            color += value.toString(16).padStart(2, '0');
        }
        return color;
    } catch (error) {
        return "red";
    }
};